<template>
    <div v-loading="loading">
        <apply-header :flag="'1'"></apply-header>
        <div class="main" :style="{'min-height':(getHeight-80)+'px'}">
             <Side :step="'2'"></Side>
            <div class="smallBox">
                <div class="viewPDF" style="cursor: none">What If Questionnaire</div>
                <el-form ref="form" :model="form" label-width="0px" :rules="rules">
                    <div>1- What if a customer asked you a question that you do not know the answer?
                            <span style="color:red">*</span></div>
                            <el-form-item prop="sub16" ref="sub16">
                                <el-input type="textarea" v-model="form.sub16" :disabled="isAdmin"></el-input>
                            </el-form-item>
                    <div>2-	What if a client told you that they were thinking about switching to a competitor?
                            <span style="color:red">*</span></div>
                            <el-form-item prop="sub17" ref="sub17">
                                <el-input type="textarea" v-model="form.sub17" :disabled="isAdmin"></el-input>
                            </el-form-item>
                    <div>3-	What would you do if a supervisor has a system in place, but you think there is a more efficient way to complete the task?<span style="color:red">*</span>
                        </div>
                            <el-form-item prop="sub18" ref="sub18">
                                <el-input type="textarea" v-model="form.sub18" :disabled="isAdmin"></el-input>
                            </el-form-item>
                    <div>4-	What if you requested essential information from a coworker, but after 3 days you still have not received it?<span style="color:red">*</span></div>
                            <el-form-item prop="sub19" ref="sub19">
                                <el-input type="textarea" v-model="form.sub19" :disabled="isAdmin"></el-input>
                            </el-form-item>
                    <div>5-	What would you do if you are unable to complete an assigned task by the expected deadline?<span style="color:red">*</span></div>
                            <el-form-item prop="sub20" ref="sub20">
                                <el-input type="textarea" v-model="form.sub20" :disabled="isAdmin"></el-input>
                            </el-form-item>
                </el-form>
                <div style="margin-top:10px">
                    <el-button class="yellowBtn" @click="submitPrepare" v-show="!isAdmin">Submit</el-button>
                    <el-button class="grayBtn" :style="{'margin-left':(isAdmin?'0px':'10px')}" @click="goBack">Back</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
 import ApplyHeader from "../../components/ApplyHeader"
import Side from '../../components/Aside.vue'
import { chat2Ascii } from "../../../static/js/util"
export default {
    components:{ApplyHeader,Side},
    data(){
        return{
            loading:false,
            isAdmin:0,
            form:{
                sub16:'',
                sub17:'',
                sub18:'',
                sub19:'',
                sub20:''
            },
            rules:{
                sub16:[{required:true,message:'Required',trigger:'blur'}],
                sub17:[{required:true,message:'Required',trigger:'blur'}],
                sub18:[{required:true,message:'Required',trigger:'blur'}],
                sub19:[{required:true,message:'Required',trigger:'blur'}],
                sub20:[{required:true,message:'Required',trigger:'blur'}]
            }
        }
    },
    created(){
        this.getData()
    },
    computed:{
        getHeight(){
            return document.documentElement.clientHeight
        }
    },
    methods:{
        submitPrepare(){
            this.$refs['form'].clearValidate()
            this.$nextTick(() => {
                this.$refs['form'].validate((valid,object) => {
                    if (valid) {
                        var params={}
                        params.email=localStorage.getItem('email')
                        for(var i =16;i<=20;i++){
                            var index = i.toString().length<2?('0'+i):i
                            params['wI'+index] = this.form['sub'+i]
                        }
                        console.log('传的值事',params)
                        this.loading = true
                        this.$axios.post(this.$URL.testBoardUrl,params).then(res=>{
                            this.loading = false
                            if(res&&res.code===0){
                                this.$message.success('Submit Success!')
                                this.goBack()
                            }
                        }).catch(err=>{
                            this.$message.error({message:err.msg})
                            this.loading = false
                        })
                    }else {
                        var obj = Object.keys(object)[0]
                        let dom = this.$refs[obj]
                        dom.$el.scrollIntoView({
                            //滚动到指定节点
                            block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
                            behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
                        })
                        console.log('error submit!!');
                        return false;
                    }
                })
            })
        },
        goBack(){
            this.$router.push({path:'/applicantHome'})
        },
        getData(){
            var email=''
            if(this.$route.query&&this.$route.query.model=='review'&&this.$route.query.verify||this.$route.query.type==0){
                if(this.$route.query.type==0){
                    email = localStorage.getItem('email')
                }else{
                    email = this.$route.query.email
                     var verify = this.$route.query.verify
                    var verifyCode = chat2Ascii(email)
                    if(verifyCode!=verify){
                        this.$router.push('/login')
                        return
                    }
                }
                 this.isAdmin = true
            }else{
                this.isAdmin = false
                email = localStorage.getItem('email')
            }
            this.loading = true
            this.$axios.get(this.$URL.testBoardUrl,{params:{email:email}}).then(res=>{
                 this.loading = false
                if(res&&res.code==0){
                    if(res.data){
                        for(var i=16;i<=20;i++){
                             var index = i.toString().length<2?('0'+i):i
                            this.form['sub'+i] = res.data['wI'+index]
                        }
                    }
                }
            }).catch(err=>{
                  this.loading = false
                  this.$message.error({message:err.msg})
            })
        },
    },
    watch:{
        $route(to,from){
            console.log(from)
            console.log('邮箱值',localStorage.getItem('email'))
            if(to.path==='/whatIfv4'){
                this.getData()
            }
        }
    }
}
</script>

<style scoped>
    .smallBox{
        margin:20px
    }
    .viewPDF{
        font-size: 18px;
        left: 12.5%;
    }
    /deep/ .el-form-item{
        margin-top: 10px;
    }
    /deep/ .el-textarea__inner{
        width: 70%;
        min-height: 100px!important;
    }
     @media screen and (max-width: 1200px) {
        .viewPDF{
            font-size: 18px;
            left: 19%;
        }
        /deep/ .el-textarea__inner{
        width: 80%;
        min-height: 100px!important;
    }
     }
     @media screen and (max-width: 1440px) {
       
     }
</style>